<template>
  <div class="o-layout__row" data-test="eherkenning-already-coupled">
    <div class="o-layout__col-xl-10">
    <h1>Dit account is al gekoppeld met eHerkenning</h1>
    <h2 class="h2--secondary">Neem contact op met je Toegangsbeheerder</h2>
    <p>eHerkenning is al gekoppeld met dit account, mogelijk is het in gebruik door iemand anders. Wil je toegang tot NN, neem voor meer informatie contact op met de Toegangsbeheerder (administrator) van het bedrijf. De Toegangsbeheerder kan een nieuw account voor je aanmaken.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AlreadyCoupled',
};
</script>
